import React from 'react';
import { FastField, FieldProps } from 'formik';
import { Checkbox, FormControlLabel } from '@material-ui/core';

interface CheckboxFastFieldProps {
  name: string;
  label: string;
  [x: string]: any;
}

const CheckboxFastField: React.FC<CheckboxFastFieldProps> = (props) => {
  const { name, label, handleChange, disabled = false, ...other } = props;
  return (
    <FastField name={name} key={`${name}-${disabled ? 'disabled' : 'enabled'}`}>
      {({
        field, // { name, value, onChange, onBlur }
        form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta,
      }: FieldProps<any>) => {
        return (
          <FormControlLabel
            disabled={disabled}
            control={
              <Checkbox
                checked={field.value ?? false}
                disabled={disabled}
                onChange={(e) => form.setFieldValue(name, e.target.checked)}
                {...other}
              />
            }
            label={label}
          />
        );
      }}
    </FastField>
  );
};

export default CheckboxFastField;
